import React from "react"
import { FiFolderPlus } from "react-icons/fi"
import MI_ext from "./_ext"

class MI_create_commu extends MI_ext {
  renderIcon = () => {
    return <FiFolderPlus />
  }
}
export default MI_create_commu
